export default function Services() {
  const services = [
    {
      icon: 'ri-settings-3-line',
      title: '安全性システム導入支援',
      description: '安全性システム導入支援サービスは、製薬企業における安全性情報管理（ファーマコビジランス）の高度化と業務効率化を実現するコンサルティングサービスです。業務プロセスの分析から最適なシステム選定、導入計画の策定、設定・テスト・データ移行、ユーザートレーニングまでを一貫してサポートします。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '規制対応支援',
      description: '製薬企業におけるファーマコビジランス業務の規制遵守をサポートするコンサルティングサービスです。国内外のガイドラインや規制要件を踏まえ、安全性業務プロセスの整備、手順書作成、運用改善、監査・査察対応まで幅広く支援します。',
    },
    {
      icon: 'ri-robot-line',
      title: '安全性システム運用のAI化',
      description: '安全性システムAI化支援サービスは、AI技術を活用して安全性システムの運用業務を自動化・効率化するサービスです。症例情報の整理、データ確認、レポート作成などの業務にAIを活用することで、作業負担の軽減と業務スピードの向上を実現します。',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'ビジネスインテリジェンス',
      description: '帳票作成支援サービスは、BIツールを活用し、安全性情報や業務データを分かりやすく可視化する帳票・レポートの作成をサポートします。お客様の業務内容や目的に応じてデータの整理・設計を行い、必要な情報を迅速に把握できるダッシュボードや分析レポートを構築します。',
    },
    {
      icon: 'ri-code-box-line',
      title: '開発/バリデーション支援',
      description: '製薬企業における安全性情報管理システムの開発から品質保証までを包括的にサポートします。要件定義や設計、テスト計画の策定、検証・文書作成など、GxPや各種規制要件に準拠したバリデーション活動を支援します。',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '安全性システムトレーニング',
      description: '製薬企業の担当者が安全性情報管理システムを正確かつ効率的に活用できるよう支援する教育サービスです。システムの基本操作から業務に即した実践的な運用方法まで、分かりやすいトレーニングを提供します。',
    },
  ];

  return (
    <section id="services" className="py-24 relative">
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/7dd31cbf5ff27eab24c37916a94af167.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-white/85"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            サービス概要
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            製薬業界に特化した専門知識と最新のIT技術を組み合わせ、<br className="hidden lg:block" />
            お客様のビジネス課題を解決します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-600 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}